import React, { useState, useEffect } from 'react';
import { Navbar } from 'flowbite-react';
import { links } from "../ui/Links";
import { Link } from "react-router-dom";
import { verify_login } from '../api/auth';
import { useNavigate } from 'react-router-dom';
import favicon from '../favicon.ico';

const Header = () => {
  const [authenticated, setAuthState] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
      const fetchData = async () => {
          try {
              const response = await verify_login();            
              if (response.authenticated) {
                setAuthState(true);
              }else{
                setAuthState(false);
                const currentPath = window.location.pathname;
                const pathdata = currentPath.split('/');
                if(pathdata.length > 2 && pathdata[1] !== "team"){
                  alert("You must be logged in to view this page.");
                  navigate('/');
                }else if(currentPath === "/profile"){
                  alert("You must be logged in to view this page.");
                  navigate('/');
                }
                //navigate('/');
              }
          } catch (error) {               
              console.error("Error fetching user settings:", error);
          }
      };
      fetchData();
  }, [navigate]);
  
  //setAuthState(false);

  return (
    <Navbar fluid={true} rounded={true}>
      <Navbar.Brand href="#">
        <img
          src={favicon}
          className="mr-3 h-6 sm:h-9"
          alt="NCPC Logo"
        />
        {/**
         * <span className="self-center whitespace-nowrap text-xl font-semibold dark:text-white">
            NCPC
          </span>
         */}
      </Navbar.Brand>
      <Navbar.Toggle />
      <Navbar.Collapse>
        {links.map(({name, path, requiresAuth, removeOnAuth}, key) => (//Need to use global state to fix this:
            ((!requiresAuth || authenticated) && !removeOnAuth) && (
              <Link to={path} key={key}>
                  {name}
              </Link>
            )
        ))}
        {links.map(({name, path, requiresAuth, removeOnAuth}, key) => (//Need to use global state to fix this:
            (!authenticated && removeOnAuth) && (
              <Link to={path} key={key}>
                  {name}
              </Link>
            )
        ))}
      </Navbar.Collapse>
    </Navbar>
  );
};

export default Header;
